<ng-container [ngSwitch]="wall.wallType">
    <app-polls-details *ngSwitchCase="'pollwall'" [id]="wall.referenceObjectId" [conferenceId]="wall.conferenceId">
    </app-polls-details>
    <app-debates-details *ngSwitchCase="'debatewall'" [id]="wall.referenceObjectId" [conferenceId]="wall.conferenceId">
    </app-debates-details>
    <app-default-wall *ngSwitchCase="'basewall'"></app-default-wall>
    <app-default-wall *ngSwitchDefault></app-default-wall>
</ng-container>